// JS INDUSTRIES SHAPERBUDDY <-> SHOPIFY CONNECTOR
              // PERISCOPE 2022

              // Add Board to cart
              function addToCart(varid){
                document.querySelector('#b_'+varid+' button').innerHTML = '<div class="lds-dual-ring"></div>';

                  let itemList = {
                    'items': [{
                      'id': varid,
                      'quantity': 1
                    }]
                  };

                  fetch(window.Shopify.routes.root + 'cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(itemList)

                }).then(response => {
                  document.querySelector('#b_'+varid+' button').innerHTML = '<svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg>';
                
                }).then(response => {
                  setTimeout(function(){ window.location.href = "/cart"; }, 800);
                
                }).catch((error) => {
                  console.error('Error:', error);
                });
              }

              // Add to Custom Order
              function addToCustomOrder(model, length, width, thickness){
                window.location.href = '/pages/custom-order?id_surfboardmodel='+model+'&co_length='+length+'&co_width='+width+'&co_thickness='+thickness+'&co_technology='+coTech;
              }

              // Toggle Fin System Filter
              function toggleFins(filter=null, button = null){
                if(filter == 'Futures'){
                  document.querySelectorAll(".instock").forEach(e => e.classList.remove("show-fins"));
                  document.querySelectorAll(".instock.Futures").forEach(e => e.classList.add("show-fins"));
                }else if(filter == 'FCS'){
                  document.querySelectorAll(".instock").forEach(e => e.classList.remove("show-fins"));
                  document.querySelectorAll(".instock.FCS").forEach(e => e.classList.add("show-fins"));
                }else{
                  document.querySelectorAll(".instock").forEach(e => e.classList.add("show-fins"));
                }
              }

              function doSomething(object, something){
                document.querySelectorAll("."+something).forEach(e => e.classList.add("hide-dimm"));
                object.classList.remove("hide-dimm");
              }

              // Toggle Colour Filter
              function toggleColour(filter=null, button = null){

                document.querySelectorAll(".sizegrid").forEach(e => e.classList.remove("hide-dimm"));
                

                if(filter == 'Black'){
                  document.querySelectorAll(".instock").forEach(e => e.classList.remove("show-colour"));
                  document.querySelectorAll(".instock.BLACK").forEach(e => e.classList.add("show-colour"));
                  document.querySelectorAll(".instock.BLACK").forEach(e => doSomething(e, e.getAttribute("data-name")));

                }else if(filter == 'Marble'){
                  document.querySelectorAll(".instock").forEach(e => e.classList.remove("show-colour"));
                  document.querySelectorAll(".instock.MARBLE").forEach(e => e.classList.add("show-colour"));
                  document.querySelectorAll(".instock.MARBLE").forEach(e => doSomething(e, e.getAttribute("data-name")));

                }else if(filter == 'Military'){
                  document.querySelectorAll(".instock").forEach(e => e.classList.remove("show-colour"));
                  document.querySelectorAll(".instock.MILITARY").forEach(e => e.classList.add("show-colour"));
                  document.querySelectorAll(".instock.MILITARY").forEach(e => doSomething(e, e.getAttribute("data-name")));

                }else if(filter == 'Grey'){
                  document.querySelectorAll(".instock").forEach(e => e.classList.remove("show-colour"));
                  document.querySelectorAll(".instock.GRAY").forEach(e => e.classList.add("show-colour"));
                  document.querySelectorAll(".instock.GRAY").forEach(e => doSomething(e, e.getAttribute("data-name")));

                }else if(filter == 'Gray'){
                  document.querySelectorAll(".instock").forEach(e => e.classList.remove("show-colour"));
                  document.querySelectorAll(".instock.GRAY").forEach(e => e.classList.add("show-colour"));
                  document.querySelectorAll(".instock.GRAY").forEach(e => doSomething(e, e.getAttribute("data-name")));

                }else if(filter == 'Green'){
                  document.querySelectorAll(".instock").forEach(e => e.classList.remove("show-colour"));
                  document.querySelectorAll(".instock.GREEN").forEach(e => e.classList.add("show-colour"));
                  document.querySelectorAll(".instock.GREEN").forEach(e => doSomething(e, e.getAttribute("data-name")));

                }else if(filter == 'Purple'){
                  document.querySelectorAll(".instock").forEach(e => e.classList.remove("show-colour"));
                  document.querySelectorAll(".instock.PURPLE").forEach(e => e.classList.add("show-colour"));
                  document.querySelectorAll(".instock.PURPLE").forEach(e => doSomething(e, e.getAttribute("data-name")));

                }else if(filter == 'Red'){
                  document.querySelectorAll(".instock").forEach(e => e.classList.remove("show-colour"));
                  document.querySelectorAll(".instock.RED").forEach(e => e.classList.add("show-colour"));
                  document.querySelectorAll(".instock.RED").forEach(e => doSomething(e, e.getAttribute("data-name")));

                }else if(filter == 'Pink'){
                  document.querySelectorAll(".instock").forEach(e => e.classList.remove("show-colour"));
                  document.querySelectorAll(".instock.PINK").forEach(e => e.classList.add("show-colour"));
                  document.querySelectorAll(".instock.PINK").forEach(e => doSomething(e, e.getAttribute("data-name")));

              

                }else if(filter == 'Blue'){
                  document.querySelectorAll(".instock").forEach(e => e.classList.remove("show-colour"));
                  document.querySelectorAll(".instock.BLUE").forEach(e => e.classList.add("show-colour"));
                  document.querySelectorAll(".instock.BLUE").forEach(e => doSomething(e, e.getAttribute("data-name")));
                }else if(filter == 'Midnight'){
                  document.querySelectorAll(".instock").forEach(e => e.classList.remove("show-colour"));
                  document.querySelectorAll(".instock.MIDNIGHT").forEach(e => e.classList.add("show-colour"));
                  document.querySelectorAll(".instock.MIDNIGHT").forEach(e => doSomething(e, e.getAttribute("data-name")));

                }else if(filter == 'Tan'){
                  document.querySelectorAll(".instock").forEach(e => e.classList.remove("show-colour"));
                  document.querySelectorAll(".instock.TAN").forEach(e => e.classList.add("show-colour"));
                  document.querySelectorAll(".instock.TAN").forEach(e => doSomething(e, e.getAttribute("data-name")));

                }else if(filter == 'Maroon'){
                  document.querySelectorAll(".instock").forEach(e => e.classList.remove("show-colour"));
                  document.querySelectorAll(".instock.MAROON").forEach(e => e.classList.add("show-colour"));
                  document.querySelectorAll(".instock.MAROON").forEach(e => doSomething(e, e.getAttribute("data-name")));

                }else if(filter == 'Clear'){
                  document.querySelectorAll(".instock").forEach(e => e.classList.remove("show-colour"));
                  document.querySelectorAll(".instock.CLEAR").forEach(e => e.classList.add("show-colour"));
                  document.querySelectorAll(".instock.CLEAR").forEach(e => doSomething(e, e.getAttribute("data-name")));

                }else if(filter == 'Sand'){
                  document.querySelectorAll(".instock").forEach(e => e.classList.remove("show-colour"));
                  document.querySelectorAll(".instock.SAND").forEach(e => e.classList.add("show-colour"));
                  document.querySelectorAll(".instock.SAND").forEach(e => doSomething(e, e.getAttribute("data-name")));

                }else if(filter == 'Storm'){
                  document.querySelectorAll(".instock").forEach(e => e.classList.remove("show-colour"));
                  document.querySelectorAll(".instock.STORM").forEach(e => e.classList.add("show-colour"));
                  document.querySelectorAll(".instock.STORM").forEach(e => doSomething(e, e.getAttribute("data-name")));

                }else if(filter == 'Rust'){
                  document.querySelectorAll(".instock").forEach(e => e.classList.remove("show-colour"));
                  document.querySelectorAll(".instock.RUST").forEach(e => e.classList.add("show-colour"));
                  document.querySelectorAll(".instock.RUST").forEach(e => doSomething(e, e.getAttribute("data-name")));

                }else if(filter == 'Black'){
                  document.querySelectorAll(".instock").forEach(e => e.classList.remove("show-colour"));
                  document.querySelectorAll(".instock.BLACK").forEach(e => e.classList.add("show-colour"));
                  document.querySelectorAll(".instock.BLACK").forEach(e => doSomething(e, e.getAttribute("data-name")));

                }else if(filter == 'Sea'){
                  document.querySelectorAll(".instock").forEach(e => e.classList.remove("show-colour"));
                  document.querySelectorAll(".instock.SEA").forEach(e => e.classList.add("show-colour"));
                  document.querySelectorAll(".instock.SEA").forEach(e => doSomething(e, e.getAttribute("data-name")));

                }else if(filter == 'Coco'){
                  document.querySelectorAll(".instock").forEach(e => e.classList.remove("show-colour"));
                  document.querySelectorAll(".instock.COCO").forEach(e => e.classList.add("show-colour"));
                  document.querySelectorAll(".instock.COCO").forEach(e => doSomething(e, e.getAttribute("data-name")));

                }else{
                  document.querySelectorAll(".instock").forEach(e => e.classList.add("show-colour"));
                }

               
              }

              // Toggle Construction Filter
              function toggleConst(filter=null, button = null){

                document.querySelectorAll(".sizegrid").forEach(e => e.classList.remove("hide-dimm"));
                
                if(filter == 'PU'){
                  document.querySelectorAll(".instock").forEach(e => e.classList.remove("show-const"));
                  document.querySelectorAll(".instock.PU").forEach(e => e.classList.add("show-const"));
                  document.querySelectorAll(".sizegrid").forEach(e => e.classList.remove("show-const"));
                  document.querySelectorAll(".sizegrid.PU").forEach(e => e.classList.add("show-const"));
                  document.querySelectorAll(".instock.PU").forEach(e => doSomething(e, e.getAttribute("data-name")));
                  coTech = 47;
                }else if(filter == 'PE'){
                  document.querySelectorAll(".instock").forEach(e => e.classList.remove("show-const"));
                  document.querySelectorAll(".instock.PE").forEach(e => e.classList.add("show-const"));
                  document.querySelectorAll(".sizegrid").forEach(e => e.classList.remove("show-const"));
                  document.querySelectorAll(".sizegrid.PE").forEach(e => e.classList.add("show-const"));
                  document.querySelectorAll(".instock.PE").forEach(e => doSomething(e, e.getAttribute("data-name")));
                  coTech = 989;
                }else if(filter == 'EPS'){
                  document.querySelectorAll(".instock").forEach(e => e.classList.remove("show-const"));
                  document.querySelectorAll(".instock.EPS").forEach(e => e.classList.add("show-const"));
                  document.querySelectorAll(".sizegrid").forEach(e => e.classList.remove("show-const"));
                  document.querySelectorAll(".sizegrid.EPS").forEach(e => e.classList.add("show-const"));
                  document.querySelectorAll(".instock.EPS").forEach(e => doSomething(e, e.getAttribute("data-name")));
                  coTech = 466;
                }else if(filter == 'HYFI'){
                  document.querySelectorAll(".instock").forEach(e => e.classList.remove("show-const"));
                  document.querySelectorAll(".instock.HYFI").forEach(e => e.classList.add("show-const"));
                  document.querySelectorAll(".sizegrid").forEach(e => e.classList.remove("show-const"));
                  document.querySelectorAll(".sizegrid.HYFI").forEach(e => e.classList.add("show-const"));
                  document.querySelectorAll(".instock.HYFI").forEach(e => doSomething(e, e.getAttribute("data-name")));
                  coTech = 1483;
                }else if(filter == 'Carbotune'){
                  document.querySelectorAll(".instock").forEach(e => e.classList.remove("show-const"));
                  document.querySelectorAll(".instock.Carbotune").forEach(e => e.classList.add("show-const"));
                  document.querySelectorAll(".sizegrid").forEach(e => e.classList.remove("show-const"));
                  document.querySelectorAll(".sizegrid.Carbotune").forEach(e => e.classList.add("show-const"));
                  document.querySelectorAll(".instock.Carbotune").forEach(e => doSomething(e, e.getAttribute("data-name")));
                  coTech = 1481;
                }else{
                  document.querySelectorAll(".instock").forEach(e => e.classList.add("show-const"));
                  document.querySelectorAll(".sizegrid").forEach(e => e.classList.add("show-const"));
                }
              }

            
              // Get Board Size Grid
              async function getBoards(model) {
                const resp = await fetch(`https://js-periscope-buddy.herokuapp.com/board-options-bali.php?model=`+model, {
                    method: 'GET'
                });

                const data = await resp.json();
                
                if(data.boards != null) {
                  return data;
                }
              }


              // Get Board Size Grid
              async function getVolume(productId) {

                var myHeaders = new Headers();
                myHeaders.append("X-Shopify-Storefront-Access-Token", "86cfe01325b4ed8b7bdd820b9eb418c3");
                myHeaders.append("Content-Type", "application/graphql");
                myHeaders.append("Cookie", "_shopify_y=12ae615c-9c74-4887-934f-a2080efa0d99; _y=12ae615c-9c74-4887-934f-a2080efa0d99; localization=AU; secure_customer_sig=");

                var raw = "{\n  product(id: \"gid://shopify/Product/"+productId+"\") {\n      volume: metafield(namespace: \"surfboard\", key: \"volume\") {\n        value\n      }\n  }\n}";

                var requestOptions = {
                  method: 'POST',
                  headers: myHeaders,
                  body: raw,
                  redirect: 'follow'
                };

                const resp = await fetch("https://js-industries-aus.myshopify.com/api/2021-07/graphql.json", requestOptions);

                const data = await resp.json();

                
                return data;
              }